<div class="table-responsive">
  <table class="table table-striped table-hover">
    <thead class="table-light">
    <tr>
      <th>Date</th>
      <th>Hour</th>
      <th>Offer</th>
      <th>Click ID</th>
      <th>IP Address</th>
      <th>SubID</th>
      <th>Tracker1</th>
      <th>Tracker2</th>
      <th>Tracker3</th>
      <th>Tracker4</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let statistic of statistics">
      <td>{{ statistic.getDate() | date: 'dd/MM/yyyy' }}</td>
      <td>{{ statistic.getDate() | date: 'HH:mm' }}</td>
      <td>
        <a *ngIf="statistic.offer" [routerLink]="['/offer', statistic.offer.id]">
          {{ statistic.offer.name }}
        </a>
      </td>
      <td>{{ statistic.clickid }}</td>
      <td>{{ statistic.ip }}</td>
      <td>{{ statistic.subid }}</td>
      <td>{{ statistic.tc1 }}</td>
      <td>{{ statistic.tc2 }}</td>
      <td>{{ statistic.tc3 }}</td>
      <td>{{ statistic.tc4 }}</td>
    </tr>
    </tbody>
  </table>
</div>

<app-paginator (pageChange)="fetchConversions()" [paginator]="paginator"></app-paginator>
